import type { FeedTeaser } from '#domains/resolver/board-section-data';

import { BoardSectionItem } from '../BoardSectionItem';

import styles from './BoardSectionItemFeed.module.scss';

type Props = {
	teasers: FeedTeaser[];
};

export function BoardSectionItemFeed({ teasers }: Props) {
	return (
		<section className={styles.wrapper}>
			<div className={styles.innerWrapper}>
				{teasers.map((boardSectionItem, index) => (
					<BoardSectionItem
						className={styles.item}
						isFeedItem={true}
						teaser={boardSectionItem}
						// eslint-disable-next-line @eslint-react/no-array-index-key
						key={`${boardSectionItem.rowId}_${index}`}
					/>
				))}
			</div>
		</section>
	);
}
